import React, { useEffect, useRef } from "react";
import MainText from "../components/Apply/MainText";
import MainTitle from "../components/Apply/MainTitle";
import ApplyDates from "../components/Apply/ApplyDates";
import BreadCrumbs from "../components/Apply/BreadCrumbs";
import { useTheme } from "@mui/styles";
import { useMediaQuery, Box } from "@mui/material";
import useQuery from "../hooks/useQuery";
import { useLocation, useNavigate } from "react-router-dom";
import { useCourses } from "../context/CourseContext";
import BackButton from "../components/ApplyForm/BackButton";
import useTranslation from "../hooks/useTranslation";

const useStyles = (theme) => ({
  container: {
    width: "100%",
    overflow: "hidden",
  },
  span: { fontWeight: "bold" },
  cardsContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: { md: "center" },
    mt: { md: "150px" },
    mb: { xs: "70px", md: "251px" },
  },
  normal: { fontWeight: "normal" },
  coursesContainer: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: "center",
    mb: "39px",
  },
  buttonContainer: {
    width: {
      xl: "1373px",
      lg: "1098px",
      md: "878.4px",
      sm: "284px",
      xs: "284px",
    },
    display: "flex",
    justifyContent: {
      xs: "center",
      sm: "center",
      md: "flex-start",
      lg: "flex-start",
      xl: "flex-start",
    },
  },
});

const ApplyIntroDates = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const navigate = useNavigate();
  const { introCourses } = useCourses();

  const isMobile = useMediaQuery("(max-width:899px)");

  const query = useQuery();
  const modality = query.get("modalidad");

  const focusElement = useRef(null);

  const focusOnElement = () => {
    focusElement.current.scrollIntoView();
  };

  useEffect(() => {
    if (focusElement) {
      focusOnElement();
    }
  }, []);

  useEffect(() => {
    if (modality === "atr") navigate("/aplica/intro/formulario?modalidad=atr");
  }, [modality, navigate]);

  const breadcrumbs = {
    first: {
      text: "Aplicá",
      link: "/aplica",
    },
    second: { text: "Con profesor", link: "" },
    third: { text: "Edición", link: "" },
  };

  const { pathname } = useLocation();
  const { title, description, img, subtitle } = useTranslation(
    pathname,
    "ApplyIntroDates"
  );

  return (
    <Box sx={classes.container}>
      <MainTitle
        title={title}
        subtitle={
          <>
            <span style={classes.span}>{description[0]}</span>
            {description[1]}
          </>
        }
        img={img}
        width={{ xs: "287px", md: "400px" }}
        mobileHeight="312px"
      />

      {!isMobile && (
        <MainText
          text={
            <>
              {subtitle[0]}
              <span style={classes.normal}>{subtitle[1]}</span>
            </>
          }
          mt={{ xs: "-113px", md: "-90px", lg: "-83px", xl: "-100px" }}
        />
      )}

      <BreadCrumbs breadcrumbs={breadcrumbs} />

      <Box sx={classes.coursesContainer} ref={focusElement}>
        {introCourses?.length > 0
          ? introCourses
              .filter(
                ({ vacancyStatus, availability, status }) =>
                  vacancyStatus && availability && status === "disponible"
              )
              .map((course, index) => {
                return (
                  <ApplyDates
                    course={course}
                    key={index}
                    pathname={"/aplica/intro/formulario"}
                  />
                );
              })
          : null}
        <Box sx={classes.buttonContainer}>
          <BackButton />
        </Box>
      </Box>
    </Box>
  );
};

export default ApplyIntroDates;
